import Swiper, {
  Navigation, Pagination, Scrollbar, Autoplay,
} from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

/**
 * Видео отзывы на странице отзывов.
 * @constructor
 */
export default function Video() {
  // eslint-disable-next-line no-new
  new Swiper('.video .swiper', {
    direction: 'horizontal',
    rewind: true,
    spaceBetween: 20,
    preloadImages: false,
    draggable: true,
    centeredSlides: false,
    centeredSlidesBounds: false,
    freeMode: {
      enabled: false,
      sticky: false,
    },
    navigation: {
      nextEl: '.video .slide-next',
      prevEl: '.video .slide-prev',
    },
    // Navigation arrows
    pagination: {
      el: '.video .swiper .swiper-pagination',
      clickable: true,
      renderBullet: (index, className) => `<div class="pagination-dot ${className}"></div>`,
    },
    breakpoints: {
      1280: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 2,
      },
      420: {
        slidesPerView: 1,
      },
      320: {
        spaceBetween: 1,
        initialSlide: 0,
        slidesPerView: 'auto',
      },
    },
  });
}
